import React from 'react';
import { Button } from 'reactstrap';

const Btn = (props) =>{
    return <Button className={props.className} style={props.style} {...props.attrBtn}>{props.children}</Button>;
};

export default Btn;